import { FeatureFlag } from '../FeatureFlag';

export const enableCodeEditorTagTree = new FeatureFlag({
    key: 'enable-code-editor-tag-tree',
    defaultValue: false,
});
